import { forwardRef, type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const spinnerVariants = cva(
  "inline-block animate-[tb-spin_0.7s_linear_infinite] rounded-full border-solid border-[color:var(--tb-border)] border-t-tb-green motion-reduce:[animation-duration:2s]",
  {
    variants: {
      size: {
        sm: "size-[18px] border-2",
        md: "size-7 border-2",
      },
    },
    defaultVariants: { size: "md" },
  },
);

export interface SpinnerProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof spinnerVariants> {
  label?: string;
}

/** Animated loading spinner, from the TB Design System. */
export const Spinner = forwardRef<HTMLSpanElement, SpinnerProps>(
  ({ className, size, label = "Carregando", ...props }, ref) => (
    <span
      ref={ref}
      role="status"
      aria-label={label}
      className={cn(spinnerVariants({ size, className }))}
      {...props}
    />
  ),
);
Spinner.displayName = "Spinner";
